<template>
  <div class="kbx-trigger-content">
    <link rel="stylesheet" :href="themeCdnUri + '/popup.css'">
    <input
      type="text"
      class="kbx-trigger-btn kbx-trigger-button"
      v-if="boxConfig.trigger_button.kind === 'basic'"
      :style="boxConfig.trigger_button.style"
      :value="boxConfig.trigger_button.text"
      @change="boxUpdateConfig({ item: 'trigger_button', key: 'text', value: $event.target.value })"/>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import rebrand from '../../../../config/rebrand';

export default {
  data() {
    return {
      themeCdnUri: rebrand.urls.THEME_CDN_URI,
    };
  },
  methods: mapActions([
    'boxUpdateConfig',
  ]),
  computed: mapGetters({
    boxConfig: 'boxConfig',
  }),
};
</script>



/** WEBPACK FOOTER **
 ** Basic.vue?6465b4f2
 **/